/** Cyrillic letters that look like Latin — map to Latin for fuzzy search */
const CYRILLIC_TO_LATIN: Record<string, string> = {
  а: 'a',
  в: 'b',
  с: 'c',
  е: 'e',
  н: 'h',
  к: 'k',
  м: 'm',
  о: 'o',
  р: 'p',
  т: 't',
  у: 'y',
  х: 'x',
}

/** Lowercase + unify Latin/Cyrillic homoglyphs so "WLC" matches "WLС" */
export function normalizeForSearch(text: string): string {
  const lower = text.toLowerCase()
  let out = ''
  for (const ch of lower) {
    out += CYRILLIC_TO_LATIN[ch] ?? ch
  }
  return out
}

export function searchTextIncludes(haystack: string, needle: string): boolean {
  if (!needle) return true
  return normalizeForSearch(haystack).includes(normalizeForSearch(needle))
}
